import axios from "axios";

export default {
    namespaced: true,
    state: {
        currentProduct: {}
    },
    mutations: {

    },
    actions: {
        getProduct(store,id){
            const url = store.rootState.shared.api_url;
            axios.get(url + "products/" + id)
                    .then(response => {
                        store.state.currentProduct = response.data
                    })
                    .catch(error => console.log(error))
        }
    },
    getters: {}
}
